export const PANEL_INLINE_SIZE = '35rem';